import { render } from "./ApplicationsGroups.vue?vue&type=template&id=f0644e3c&scoped=true"
import script from "./ApplicationsGroups.vue?vue&type=script&lang=js"
export * from "./ApplicationsGroups.vue?vue&type=script&lang=js"

import "@/styles/profile/webinars/applications.scss?vue&type=style&index=0&id=f0644e3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0644e3c"]])

export default __exports__